import React from 'react';
import { withLazyComponent } from './with-lazy-component';
import { ControlGroupSkeleton } from "../components/loading/control-group-skeleton";

const Component = React.lazy(() => import('../components/items-counter'));

export default function (dependencies) {
    const { language } = dependencies;

    const html = (props) => {
        const LazyComponent = withLazyComponent(Component, ControlGroupSkeleton);
        return LazyComponent({ ...props, ...dependencies });
    };

    return {
        html,
        validators: [
             (state) => {
                if (state.validationResult?.count > 0) {
                    return false;
                } else {
                    return language["error-min-rooms"]
                }
            },
        ],
        config: {},
    };
}